<template>
	<div class="main">
		<hwk-header></hwk-header>
		<div class="warp order-list">
			<hwk-left type="afterSalesList"></hwk-left>
			<div class="o-l-r">
				<div class="top-nav flex">
					<div class="item" :class="{on:navindex==index}" v-for="(item,index) in navlist" :key="index"
						@click="changeNav(index)">{{item}}</div>
				</div>
				<div class="filter" v-if="filterShow">
					<el-form ref="form" :model="form" label-width="90px" label-position="right">
						<table class="table-form">
							<tr>
								<td>
									<el-form-item label="订单号">
										<el-input v-model="form.order_number" placeholder="请输入订单号" clearable></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="售后订单号">
										<el-input v-model="form.refund_order_number" placeholder="请输入售后订单号"
											clearable></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="售后类型">
										<el-select v-model="form.type" placeholder="全部" style="width: 100%;" clearable>
											<el-option label="退货退款" value="1"></el-option>
											<el-option label="补发配件" value="2"></el-option>
											<el-option label="订单异常" value="3"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>
									<div class="footer-btn">
										<div class="btn1 pointer" @click="reset">取 消</div>
										<div class="btn2 pointer" @click="submit">保 存</div>
									</div>
								</td>
							</tr>
							<!-- <tr>
								<td>
									<el-form-item label="订单号">
										<el-input v-model="form.refund_order_number" placeholder="请输入订单号"></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="订单号">
										<el-input v-model="form.refund_order_number" placeholder="请输入店铺订单编号"></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="发货单号">
										<el-input v-model="form.name" placeholder="请输入发货单号"></el-input>
									</el-form-item>
								</td>
							</tr>
							<tr>
								<td>
									<el-form-item label="下单日期">
										<el-date-picker v-model="form.value1" style="width: 100%;" type="daterange"
											range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
										</el-date-picker>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="出售平台">
										<el-input v-model="form.name" placeholder="请输入"></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="出售店铺">
										<el-input v-model="form.name" placeholder="请输入"></el-input>
									</el-form-item>
								</td>
							</tr>
							<tr>
								<td>
									<el-form-item label="发货仓库">
										<el-select v-model="form.region" placeholder="全部" style="width: 100%;">
											<el-option label="区域一" value="shanghai"></el-option>
											<el-option label="区域二" value="beijing"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="收货人">
										<el-input v-model="form.name" placeholder="请输入"></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="支付方式">
										<el-select v-model="form.region" placeholder="全部" style="width: 100%;">
											<el-option label="区域一" value="shanghai"></el-option>
											<el-option label="区域二" value="beijing"></el-option>
										</el-select>
									</el-form-item>
								</td>
							</tr>
							<tr>
								<td>
									<el-form-item label="签名">
										<el-select v-model="form.region" placeholder="全部" style="width: 100%;">
											<el-option label="区域一" value="shanghai"></el-option>
											<el-option label="区域二" value="beijing"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="订单类型">
										<el-select v-model="form.region" placeholder="全部" style="width: 100%;">
											<el-option label="区域一" value="shanghai"></el-option>
											<el-option label="区域二" value="beijing"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>
									<div class="footer-btn">
										<div class="btn1">取 消</div>
										<div class="btn2">保 存</div>
									</div>
								</td>
							</tr> -->
						</table>
					</el-form>
				</div>
				<div class="search flex">
					<div class="sl">共查询到 <span>{{total}}</span>个订单</div>
					<div class="sr flex">
						<div class="s1"><el-input placeholder="请输入" @change="search" v-model="keyword" clearable>
								<i slot="suffix" class="el-input__icon el-icon-search"></i>
							</el-input></div>
						<div class="s2 pointer" @click="filterShow=!filterShow">
							<img src="@/assets/filter.png" alt="" /><span>筛选</span>
						</div>
						<div class="s2 pointer" @click="exportOrder"><img src="@/assets/file.png"
								alt="" /><span>导出</span></div>
					</div>
				</div>
				<div class="hwk-order-list">
					<div class="t flex">
						<div class="i i1" @click="changeAll">
							<img src="@/assets/f2.png" alt="" v-if="checked" />
							<img src="@/assets/f1.png" alt="" v-else />
						</div>
						<div class="i i2">商品</div>
						<div class="i i3" style="text-align: center;">售后类型</div>
						<div class="i i3" style="text-align: center;">退款金额</div>
						<div class="i i3">订单操作</div>
					</div>
					<div class="item" v-for="(item,index) in list" :key="index">
						<div class="i-top flex">
							<div class="i i1" @click="changeChecked(item,index)">
								<img src="@/assets/f2.png" alt="" v-if="item.checked" />
								<img src="@/assets/f1.png" alt="" v-else />
							</div>
							<div class="i i2">
								{{$timeFormat(item.updatetime,'yyyy-mm-dd')||$timeFormat(item.createtime,'yyyy-mm-dd')}}
							</div>
							<div class="i i3">
								售后：{{item.refund_order_number}} <span @click="pageToOrder(item.order.id)">交易订单</span><i
									class="el-icon-arrow-right"></i>
							</div>
							<div class="i i4" v-if="item.status == 1">
								待处理</div>
							<div class="i i4" v-if="item.status == 2">
								已处理</div>
							<div class="i i4" v-if="item.status == 3">
								已驳回</div>
						</div>
						<div class="i-middle flex">
							<div class="i1">
								<div class="ii flex" v-for="(item2,index2) in item.order_goods" :key="index2">
									<img :src="http + item2.goods_image" alt="" />
									<div class="con">
										<div class="name">{{item2.goods_title}}</div>
										<div class="p">{{item.order.warehouse_string}}</div>
										<div class="p">{{item2.goods_child_sku_string}}</div>
									</div>
								</div>
							</div>
							<div class="i3">
								<p v-if="item.type == 1">退货退款</p>
								<p v-if="item.type == 2">补发配件</p>
								<p v-if="item.type == 3">订单异常</p>
							</div>
							<div class="i4">
								<p v-if="item.refund_price != '0.00'">￥{{item.refund_price}}</p>
								<p v-else>-</p>
							</div>
							<div class="i5">
								<p @click="toDetails(item.id)">详情</p>
							</div>

						</div>
						<div class="i-bottom" v-if="item.type == 2 && item.status ==2">
							<p><span>收货人：{{item.order_address.name}}</span><span>收货地：{{item.order_address.country}}</span><span
									v-if="item.status == 2">快递公司：{{item.logistics_company}}</span><span
									v-if="item.status == 2">发货单号：{{item.logistics_number}}</span>
							</p>
						</div>
						<div class="i-bottom2" v-if="item.status == 3">
							<div class="con">
								<img src="@/assets/warning.png" alt="warning" /><span>驳回原因：{{item.reply_message}}</span>
							</div>

						</div>
					</div>
				</div>
				<div class="pagination">
					<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<navigation :usershow='false'></navigation>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import hwkLeft from './hwk-left.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation,
			hwkLeft
		},
		data() {
			return {
				keyword: "",
				filterShow: false,
				form: {
					refund_order_number: "",
					type: "",
					order_number: ""
				},
				navlist: ['全部订单', '待处理', '已处理', '拒绝处理'],
				navindex: 0,
				show1: false,
				show2: false,
				list: [],
				pageSize: 10,
				page: 1,
				input3: "",
				checked: false,
				currentPage: 1,
				total: 0,
				http: this.$imgUrl,
				status: ""

			};
		},
		created() {
			if (this.$route.query.orderNum) {
				this.form.order_number = this.$route.query.orderNum
			}


			this.getlist();
		},
		methods: {
			changeChecked(item, index) {
				item.checked = !item.checked
				this.checked = this.list.every(item => item.checked)
				this.$forceUpdate()
			},
			changeAll() {
				this.checked = !this.checked
				this.list.forEach(item => item.checked = this.checked)
			},
			search() {
				console.log(2222)
				this.getlist();
			},
			submit() {
				this.getlist();
			},
			reset() {
				this.form = {
					refund_order_number: "",
					type: "",
					order_number: ''
				}
				this.getlist();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.currentPage = val
				this.getlist();
			},
			changeNav(index) {
				if (this.navindex != index) {
					this.navindex = index
					this.status = this.navindex == 0 ? '' : this.navindex
					this.getlist();
				}
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			pageToOrder(id) {
				this.$router.push({
					path: "/orderDetails",
					query: {
						id: id,
						operate: 'details'
					}
				});
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/afterSalesDetails",
					query: {
						id: id
					}
				});
			},
			exportOrder() {
				this.$confirm('导出订单信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/order_refund/index', {
						responseType: 'blob',
						params: {
							page: this.currentPage,
							limit: this.pageSize,
							status: this.status,
							type: this.form.type,
							refund_order_number: this.form.refund_order_number,
							order_number: this.form.order_number,
							search: this.keyword,
							export: 1

						}
					}).then(res => {
						// let url = URL.createObjectURL(res);

						// 创建一个临时的 <a> 元素用于下载
						const url = window.URL.createObjectURL(new Blob([res]));
						const link = document.createElement('a');
						link.href = url;
						let filename = `售后订单导出${new Date().getTime()}.xlsx`;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						link.remove(); // 下载完成后移除
						window.URL.revokeObjectURL(url); // 释放内存
						console.log(url)
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},

			getlist() {

				this.$http.get('/api/order_refund/index', {
					params: {
						page: this.currentPage,
						limit: this.pageSize,
						status: this.status,
						type: this.form.type,
						refund_order_number: this.form.refund_order_number,
						order_number: this.form.order_number,
						search: this.keyword,
						export: 0
					}
				}).then(res => {
					this.list = res.data.data
					this.list.forEach(item => item.checked = false)

					this.total = res.data.total
				}); // 调用后端接口

			},
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.table-form {

		td {
			width: 33.33%;

			.el-form-item {
				margin-bottom: 0 !important;
			}
		}
	}

	.order-list {
		background-color: #fff;
		padding: 20px;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		border-radius: 10px;

		.hwk-order-list {
			margin-top: 20px;
			width: 100%;

			.item {
				margin-bottom: 20px;

				.i-top {
					width: 100%;
					line-height: 40px;
					height: 40px;
					background: #F0F2FA;
					border-radius: 6px;
					align-items: center;
					justify-content: space-between;
					box-sizing: border-box;

					.i {
						text-align: left;
						font-size: 14px;
						color: @color1;
					}

					.i1 {
						width: 40px;
						text-align: center;

						img {
							width: 16px;
							height: 16px;
						}
					}

					.i2 {
						width: 100px;
						text-align: center;
					}

					.i3 {
						flex: 1;
						width: 1px;
						cursor: pointer;

						span {
							color: #3572F5;
							margin-left: 10px;
							font-size: 14px;
						}

						i {
							color: #3572F5;

						}
					}

					.i4 {
						width: 100px;
						color: @color1;
						font-size: 14px;
					}

				}

				.i-middle {
					align-items: flex-start;

					.i1 {

						flex: 1;
						width: 1px;

						.ii {
							padding: 10px 0;
							display: flex;
							align-items: flex-start;
							justify-content: space-between;
						}



						img {
							width: 50px;
							height: 50px;
							background: #FFFFFF;
							border-radius: 6px 6px 6px 6px;
							border: 1px solid #D8D8D8;
							overflow: hidden;
						}

						.con {
							flex: 1;
							width: 1px;
							margin-left: 10px;

							.name {

								font-weight: 500;
								font-size: 14px;
								color: @color1;
								line-height: 20px;
								text-align: left;

							}

							.p {
								font-size: 12px;
								color: #50607A;
								line-height: 20px;
								text-align: left;
							}
						}
					}

					.i2 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;
						}
					}

					.i3 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;
							text-align: center;

							span {
								color: #868E99;
								font-size: 12px;
							}
						}
					}

					.i4 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;
							text-align: center;
						}
					}

					.i5 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: #868E99;

						p {
							line-height: 30px;
							text-align: left;
							cursor: pointer;

							span {
								color: @color2;
								margin-right: 10px;
							}
						}
					}

				}

				.i-bottom2 {
					padding-left: 50px;
					margin-top: 20px;

					.con {

						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						width: 100%;
						padding: 5px;
						box-sizing: border-box;
						background: #FFF5EE;
						border-radius: 6px;
					}

					img {
						width: 20px;
						height: 20px;
					}

					span {
						flex: 1;
						width: 1px;
						margin-left: 10px;
						font-size: 14px;
						color: #868E99;

					}
				}

				.i-bottom {
					padding-left: 50px;
					position: relative;

					p {
						text-align: left;
						padding: 5px;
						color: #768098;
						font-size: 14px;
						border-radius: 6px;
						background-color: #F5F7FD;
						text-indent: 10px;

						span {
							margin-right: 30px;
						}
					}

					.sh {
						align-items: center;
						justify-content: flex-end;
						position: absolute;
						right: 10px;
						bottom: 5px;

						img {
							width: 15px;
							height: 15px;
							margin-right: 5px;
						}

						span {
							font-size: 12px;
							color: #FF1717;
						}
					}
				}
			}

			.t {
				height: 40px;
				line-height: 40px;
				background: #F7F9FA;
				border-radius: 6px;
				width: 100%;
				margin-bottom: 10px;

				.i {
					font-size: 14px;
					color: @color1;

				}

				.i1 {

					width: 40px;
					text-align: center;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					justify-content: center;

					img {
						width: 16px;
						height: 16px;
					}
				}

				.i2 {
					flex: 1;
					width: 1px;
				}

				.i3 {
					width: 100px;
				}
			}

		}

		.o-l-r {
			flex: 1;
			width: 1px;
			margin-left: 20px;

			.search {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 20px;

				.sl {

					font-size: 14px;
					color: @color1;
					text-align: left;

					span {
						color: @color2;
						padding: 0 5px;
					}
				}

				.sr {
					flex: 1;
					width: 1px;
					display: flex;
					align-items: center;
					justify-content: flex-end;

					.s1 {
						width: 353px;
					}

					.s2 {
						margin-left: 20px;
						width: 100px;
						height: 34px;
						line-height: 34px;
						background: #FFFFFF;
						border-radius: 20px;
						border: 1px solid #D9D9D9;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 16px;
							height: 16px;
							margin-right: 5px;
						}

						span {
							color: #868E99;
							font-size: 14px;
						}
					}
				}
			}

			.filter {
				margin-top: 20px;
				border-bottom: 1px solid #eee;
			}

			.top-nav {
				display: flex;
				align-items: center;

				text-align: center;
				border-bottom: 1px solid #eee;

				.item {
					height: 40px;
					line-height: 40px;
					font-size: 16px;
					color: @color1;
					padding: 0 30px;
					cursor: pointer;
				}

				.on {
					color: @color2;
					position: relative;

					&::after {
						content: "";
						position: absolute;
						width: 56px;
						height: 3px;
						background: @color2;
						border-radius: 6px 6px 6px 6px;
						bottom: 0;
						left: 50%;
						margin-left: -28px;
					}
				}
			}
		}


	}

	.pagination {
		padding: 20px 0;
	}

	.footer-btn {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-align: center;

		.btn1 {
			width: 100px;
			height: 34px;
			background: #FFFFFF;
			border-radius: 20px 20px 20px 20px;
			border: 1px solid #D9D9D9;
			color: #868E99;
			font-size: 14px;
			line-height: 34px;
		}

		.btn2 {
			width: 100px;
			height: 34px;
			line-height: 34px;
			background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
			border-radius: 30px 30px 30px 30px;
			color: #fff;
			font-size: 14px;
			margin-left: 20px;
		}
	}
</style>